/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Load_Groups_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to load groups: {error}" |
*
* @param {Explorer_Info_Load_Groups_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_load_groups_failed_toast = /** @type {((inputs: Explorer_Info_Load_Groups_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Load_Groups_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du chargement des groupes : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gruppen konnten nicht geladen werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile caricare i gruppi: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось загрузить группы: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al cargar los grupos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`加载组失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループの読み込みに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`समूह लोड करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao carregar os grupos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to load groups: ${i?.error}`)
});